import React from "react";
import CSS from "react-css-modules";
import Fade from "react-reveal/Fade";
import { Helmet } from "react-helmet-async";
import Header from "app/components/common/Header";

import backgroundStudio from "assets/images/background_studio2.jpg";
import appleIconBlack from "assets/images/apple.png";
import windowIcon from "assets/images/window.png";
import pdfIcon from "assets/images/ic_pdf.png";

import styles from "./style.scss";

class Studio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      studioVersion: "1.1.1",
    };
  }

  componentWillMount() {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://s3.ap-northeast-2.amazonaws.com/chatie-misc/studio/releases/latest.yml"
    );
    xhr.onload = () => {
      const regex = /(\d+\.)(\d+\.)(\d)/;
      this.setState({
        studioVersion: xhr.responseText.match(regex)[0],
      });
    };
    xhr.setRequestHeader("Access-Control-Allow-Headers", "*");
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.send();
  }

  render() {
    const { studioVersion } = this.state;
    return (
      <React.Fragment>
        <Helmet>
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Header />
        <div styleName="studio">
          <div
            styleName="studio__main"
            style={{
              backgroundImage: `url(${backgroundStudio})`,
            }}
          >
            <Fade>
              <div styleName="studio__main__contents">
                <h4>채티 스튜디오로</h4>
                <h4>당신의 이야기를 담아보세요</h4>
                <p>보다 전문적이며 다양한 기능을 가진 pc스튜디오로</p>
                <p>더욱 재밌는 이야기를 만들 수 있습니다</p>
                <a
                  href={`https://s3.ap-northeast-2.amazonaws.com/chatie-misc/studio/releases/ChatieStudio-${studioVersion}-universal.dmg`}
                  download
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={appleIconBlack} alt="애플" />
                    <span>Download for MAC</span>
                  </button>
                </a>
                <a
                  href={`https://s3.ap-northeast-2.amazonaws.com/chatie-misc/studio/releases/ChatieStudio+Setup+${studioVersion}.exe`}
                  download
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={windowIcon} alt="윈도우" />
                    <span>Download for Window</span>
                  </button>
                </a>
                <a
                  download
                  href="https://s3.ap-northeast-2.amazonaws.com/chatie-misc/studio/releases/ChatieStudioGuide.pdf"
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={pdfIcon} alt="pdf" />
                    <span>Download Guide</span>
                  </button>
                </a>
              </div>
            </Fade>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const Component = CSS(Studio, styles, { allowMultiple: true });

export default Component;



// WEBPACK FOOTER //
// ./src/app/pages/Studio/index.js